import { Img } from '@chakra-ui/react';
import React from 'react';
import Spin from '../images/spin.svg';
import './loading.css';

function LoadingImg() {
  return <Img src={Spin} className="rotate" />;
}

export default LoadingImg;
